<template>
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div>
        <blue-title class="style">营业执照</blue-title>
        <Beneficiary
          :count.sync="count"
          :allData="allData"
          @salesScenesType="salesScenesType"
          @confirm="handleValidityBeneficiary"
        ></Beneficiary>
      </div>
      <div v-if="salesScenesTypeList.includes('SALES_SCENES_STORE')">
        <blue-title class="style">线下门店</blue-title>
        <OfflineStore
          :count.sync="count"
          :allData="allData"
          :provinceListData="provinceListData"
          :cityListData="cityListData"
          @changeProvince="changeProvince"
          @storeEntrancePicMediaId="storeEntrancePicMediaId"
          @indoorPicMediaId="indoorPicMediaId"
          @confirm="handleValidityOfflineStore"
        ></OfflineStore>
      </div>
      <div v-if="salesScenesTypeList.includes('SALES_SCENES_MP')">
        <blue-title class="style">公众号</blue-title>
        <OfficialAccount
          :count.sync="count"
          :allData="allData"
          @confirm="handleValidityOfficialAccount"
        ></OfficialAccount>
      </div>
      <div v-if="salesScenesTypeList.includes('SALES_SCENES_MINI_PROGRAM')">
        <blue-title class="style">小程序</blue-title>
        <Applet
          :count.sync="count"
          :allData="allData"
          @confirm="handleValidityApplet"
          @handleMediaIdMiniProgramPics="handleMediaIdMiniProgramPics"
        ></Applet>
      </div>
      <div v-if="salesScenesTypeList.includes('SALES_SCENES_APP')">
        <blue-title class="style">APP</blue-title>
        <APP :count.sync="count" :allData="allData" @confirm="handleValidityAPP"></APP>
      </div>
      <div v-if="salesScenesTypeList.includes('SALES_SCENES_WEB')">
        <blue-title class="style">互联网网站</blue-title>
        <Internet :count.sync="count" :allData="allData" @confirm="handleValidityInternet"></Internet>
      </div>
      <div v-if="salesScenesTypeList.includes('SALES_SCENES_WEWORK')">
        <blue-title class="style">企业微信</blue-title>
        <WeChat :count.sync="count" :allData="allData" @confirm="handleValidityWeChat"></WeChat>
      </div>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="info" @click="count++">保存草稿</el-button>
        <el-button type="primary" @click="count++">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Beneficiary from '../../components/operateInfo/beneficiary';
import OfflineStore from '../../components/operateInfo/offlineStore';
import OfficialAccount from '../../components/operateInfo/officialAccount';
import Applet from '../../components/operateInfo/applet';
import APP from '../../components/operateInfo/APP';
import Internet from '../../components/operateInfo/Internet';
import WeChat from '../../components/operateInfo/WeChat';
import { saveEditDraft, draftEcho, provinceList, cityList, mediaId } from '../../../../api/module/merchants';

export default {
  components: {
    Beneficiary,
    OfflineStore,
    OfficialAccount,
    Applet,
    APP,
    Internet,
    WeChat,
  },
  props: {},
  data() {
    return {
      weChatInfo: {
        subCorpId: '',
        weworkPics: [],
      },
      OfflineStoreInfo: {
        bizStoreName: '',
        bizAddressCode: '',
        bizStoreAddress: '',
        storeEntrancePic: '',
        indoorPic: '',
        bizSubAppid: '',
        province: '',
      },
      beneficiaryInfo: {
        merchantShortname: '',
        servicePhone: '',
        salesScenesType: [],
      },
      OfficialAccountInfo: {
        mpAppidBelong: 0,
        mpAppid: '',
        mpSubAppid: '',
        mpPics: [],
      },
      AppletInfo: {
        miniProgramAppid: '',
        miniProgramSubAppid: '',
        miniAppidBelong: '0',
        miniProgramPics: [],
      },
      aPPInfo: {
        appAppidBelong: '0',
        appAppid: '',
        appSubAppid: '',
        appPics: [],
      },
      internetInfo: {
        domain: '',
        webAuthorisation: '',
        webAppid: '',
      },
      count: 0, // 是否开始验证
      salesScenesTypeList: [],
      provinceListData: [],
      cityListData: [],
      weChatPass: false, // 验证企业微信
      OfflineStorePass: false,
      beneficiaryPass: false,
      OfficialAccountPass: false,
      AppletPass: false,
      appPass: false,
      internetPass: false,
      allData: {},
      storeEntrancePicMedia: '',
      indoorPicMediaIdValue: '',
      miniProgramPicsMediaId: '',
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    typeEdit() {
      return this.$route.query.type;
    },
    subjectName() {
      return this.$route.query.subjectName;
    },
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
  },
  watch: {},
  created() {
    this.provinceList();
    if (this.typeEdit == 'edit') {
      this.draftEcho();
    }
  },
  methods: {
    // 验证企业微信
    handleValidityWeChat({ flag, ruleForm }) {
      this.weChatInfo = { ...ruleForm };
      this.weChatPass = flag;
      this.handleSave();
    },
    // 验证线下门店
    handleValidityOfflineStore({ flag, ruleForm }) {
      this.OfflineStoreInfo = { ...ruleForm };
      this.OfflineStorePass = flag;
      this.handleSave();
    },
    // 验证营业执照
    handleValidityBeneficiary({ flag, ruleForm }) {
      this.beneficiaryInfo = { ...ruleForm };
      this.beneficiaryPass = flag;
      this.handleSave();
    },
    // 验证公众号
    handleValidityOfficialAccount({ flag, ruleForm }) {
      this.OfficialAccountInfo = { ...ruleForm };
      this.OfficialAccountPass = flag;
      this.handleSave();
    },
    handleValidityApplet({ flag, ruleForm }) {
      this.AppletInfo = { ...ruleForm };
      this.AppletPass = flag;
      this.handleSave();
    },
    handleValidityAPP({ flag, ruleForm }) {
      this.aPPInfo = { ...ruleForm };
      this.appPass = flag;
      this.handleSave();
    },
    handleValidityInternet({ flag, ruleForm }) {
      this.internetInfo = { ...ruleForm };
      this.internetPass = flag;
      this.handleSave();
    },
    handleSave() {
      const { weChatPass, OfflineStorePass, beneficiaryPass, OfficialAccountPass, AppletPass, appPass, internetPass } =
        this;
      const { beneficiaryInfo } = this;
      console.log(beneficiaryInfo.salesScenesType);
      if (beneficiaryInfo.salesScenesType.includes('SALES_SCENES_STORE')) {
        if (beneficiaryPass && OfflineStorePass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (beneficiaryInfo.salesScenesType.includes('SALES_SCENES_MP')) {
        if (beneficiaryPass && OfficialAccountPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (beneficiaryInfo.salesScenesType.includes('SALES_SCENES_MINI_PROGRAM')) {
        if (beneficiaryPass && AppletPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (beneficiaryInfo.salesScenesType.includes('SALES_SCENES_APP')) {
        if (beneficiaryPass && appPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (beneficiaryInfo.salesScenesType.includes('SALES_SCENES_WEB')) {
        if (beneficiaryPass && internetPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (beneficiaryInfo.salesScenesType.includes('SALES_SCENES_WEWORK')) {
        if (beneficiaryPass && weChatPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      }
      // if (
      //   beneficiaryPass &&
      //   weChatPass &&
      //   OfflineStorePass &&
      //   OfficialAccountPass &&
      //   AppletPass &&
      //   appPass &&
      //   internetPass
      // ) {
      //   const obj = this.formatSubmitData();
      //   console.log('处理后的数据===', obj);
      //   // this.saveEditDraft(obj);
      // }
    },
    formatSubmitData() {
      let obj = {};
      // const { id } = this.$route.query;
      const {
        weChatInfo,
        OfflineStoreInfo,
        beneficiaryInfo,
        OfficialAccountInfo,
        AppletInfo,
        aPPInfo,
        internetInfo,
        uuid,
        merchantId,
        storeEntrancePicMedia,
        indoorPicMediaIdValue,
        miniProgramPicsMediaId,
      } = this;
      obj = {
        businessDataVO: {
          appAppidBelong: aPPInfo.appAppidBelong,
          appAppid: aPPInfo.appAppid,
          appPics: aPPInfo.appPics.join(','),
          appSubAppid: aPPInfo.appSubAppid,
          province: OfflineStoreInfo.province,
          bizAddressCode: OfflineStoreInfo.bizAddressCode,
          bizStoreAddress: OfflineStoreInfo.bizStoreAddress,
          bizStoreName: OfflineStoreInfo.bizStoreName,
          bizSubAppid: OfflineStoreInfo.bizSubAppid,
          storeEntrancePicMedia,
          indoorPicMedia: indoorPicMediaIdValue,
          miniProgramPicsMedia: miniProgramPicsMediaId,
          domain: internetInfo.domain,
          indoorPic: OfflineStoreInfo.indoorPic,
          merchantShortname: beneficiaryInfo.merchantShortname,
          miniAppidBelong: AppletInfo.miniAppidBelong,
          miniProgramAppid: AppletInfo.miniProgramAppid,
          miniProgramPics: AppletInfo.miniProgramPics.join(','),
          miniProgramSubAppid: AppletInfo.miniProgramSubAppid,
          mpAppid: OfficialAccountInfo.mpAppid,
          mpPics: OfficialAccountInfo.mpPics.join(','),
          mpSubAppid: OfficialAccountInfo.mpSubAppid,
          mpAppidBelong: OfficialAccountInfo.mpAppidBelong,
          salesScenesType: beneficiaryInfo.salesScenesType.join(','),
          servicePhone: beneficiaryInfo.servicePhone,
          storeEntrancePic: OfflineStoreInfo.storeEntrancePic,
          subCorpId: weChatInfo.subCorpId,
          uuid: '',
          webAppid: internetInfo.webAppid,
          webAuthorisation: internetInfo.webAuthorisation,
          weworkPics: weChatInfo.weworkPics.join(','),
        },
        uuid,
        merchantId,
        type: 'business',
        listVO: {
          status: 0,
          subjectType: this.subjectName,
          merchantType: this.facilitatorName,
        },
      };
      return obj;
    },
    storeEntrancePicMediaId(url, fileName) {
      this.mediaId(url, fileName);
    },
    indoorPicMediaId(url, fileName) {
      this.mediaId1(url, fileName);
    },
    handleMediaIdMiniProgramPics(url, fileName) {
      this.mediaId2(url, fileName);
    },
    async mediaId(url, fileName) {
      const { merchantId } = this;
      const result = await mediaId({
        baseUrl: url,
        fileName,
        merchantId,
      });
      this.storeEntrancePicMedia = result.mediaId;
      console.log('storeEntrancePicMedia', result.mediaId);
    },
    async mediaId1(url, fileName) {
      const { merchantId } = this;
      const result = await mediaId({
        baseUrl: url,
        fileName,
        merchantId,
      });
      this.indoorPicMediaIdValue = result.mediaId;
      console.log('indoorPicMediaId', result.mediaId);
    },
    async mediaId2(url, fileName) {
      const { merchantId } = this;
      const result = await mediaId({
        baseUrl: url,
        fileName,
        merchantId,
      });
      this.miniProgramPicsMediaId = result.mediaId;
      console.log('indoorPicMediaId', result.mediaId);
    },
    changeProvince(val) {
      this.cityList(val);
    },
    async provinceList() {
      const result = await provinceList({});
      this.provinceListData = result;
    },
    async cityList(val) {
      const result = await cityList({
        provinceCode: val,
      });
      this.cityListData = result;
    },
    async saveEditDraft(obj) {
      console.log(obj);
      try {
        const result = await saveEditDraft({ ...obj });
        console.log('保存结果', result);
        this.$message({
          message: '保存成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$router.replace({
              path: '/merchants/addMerchants',
              query: {
                id: this.id,
                subjectName: this.subjectName,
                facilitatorName: this.facilitatorName,
                type: 'edit',
                uuid: result,
                merchantId: this.merchantId,
              },
            });
          },
        });
      } catch (err) {
        this.$message({
          message: '保存失败',
          type: 'warring',
          duration: 1500,
        });
      }
    },
    back() {
      this.$router.replace({
        path: '/merchants/addMerchants',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.typeEdit,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    async draftEcho() {
      const result = await draftEcho({
        uuid: this.uuid,
      });
      this.allData = result;
      console.log('回显所填信息', result);
    },
    salesScenesType(val) {
      console.log(val);
      this.salesScenesTypeList = val;
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  padding-top: 20px;
  .style {
    margin-bottom: 9px;
  }
  .btn {
    box-sizing: border-box;
    padding-left: 31px;
    margin-top: 57px;
    padding-bottom: 100px;
  }
}
</style>
